import React, { Component } from 'react';
import $ from 'jquery';
import { Panel } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


/* 词性速差 */
class Part extends Component {

  constructor(props) {
    super(props);
    this.state = {
      parts: [
      	{"id":1,"value":"prep.","caption":"介词"},
        {"id":2,"value":"pron.","caption":"代词"},
	{"id":3,"value":"conj.","caption":"连接词"},
	{"id":5,"value":"adv.","caption":"副词"},
	{"id":6,"value":"num.","caption":"数词"},
	{"id":7,"value":"interj.","caption":"感叹词"},
	{"id":8,"value":"pl.","caption":"特殊形式复数"},
      ],
      words: [],
    };
    this.partChange = this.partChange.bind(this);
  }

  partChange(event) {
    const part = event.target.value;
    var that = this;
    if (part !== '') {
      $(function(){$.ajax({
        url: URL + 'api/words/part/'+part+'/',
        headers: {},
        type: "GET",
        dataType: "json",
        success: function(data) {
          that.setState({words:data,});
        },
        error: function(xhr, status, err) {
          console.log(err.Message);
          alert('Error:'+err.Message);
        } 
      })});
    }
  }

  render() {
    const partOptions = this.state.parts.map((part)=>
      <option key={part.id} value={part.value}>{part.caption}</option>
      );
    return(
      <Panel>
        <Panel.Heading>
            <select name="part_select" onChange={this.partChange}>
            <option key={100} value=''>请选择词性</option>
            { partOptions }
          </select>
        </Panel.Heading>
        <Panel.Body>
	    <BootstrapTable
	        data = { this.state.words }
		striped
		hover
		options = {{ noDataText: '没有可以显示的数据' }}
	    >
	        <TableHeaderColumn isKey hidden dataField='id'>ID</TableHeaderColumn>
	        <TableHeaderColumn dataField='chinese'>中文</TableHeaderColumn>
	        <TableHeaderColumn dataField='english'>单词</TableHeaderColumn>
	    </BootstrapTable>
        </Panel.Body>
      </Panel>
    )
  }
}


export default Part;



// WEBPACK FOOTER //
// ./src/Part.js